
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

// Mock data for notifications
const mockNotifications = [
  {
    id: '1',
    title: 'New Order Received',
    message: 'Order #ORD-2024-001 has been placed by customer John Doe',
    date: '2024-01-15T10:30:00Z',
    read: false,
    recipientRole: 'sales'
  },
  {
    id: '2',
    title: 'QC Inspection Required',
    message: 'Item #ITM-001 requires quality inspection',
    date: '2024-01-15T09:15:00Z',
    read: false,
    recipientRole: 'qc'
  },
  {
    id: '3',
    title: 'Warranty Claim Approved',
    message: 'Warranty claim #WC-001 has been approved for processing',
    date: '2024-01-14T16:45:00Z',
    read: true,
    recipientRole: 'customer'
  },
  {
    id: '4',
    title: 'Monthly Report Ready',
    message: 'December 2023 financial report is ready for review',
    date: '2024-01-14T14:20:00Z',
    read: true,
    recipientRole: 'admin'
  },
  {
    id: '5',
    title: 'Inventory Low Stock Alert',
    message: 'Gold rings inventory is running low (5 units remaining)',
    date: '2024-01-14T11:30:00Z',
    read: false,
    recipientRole: 'manager'
  }
];

export const useNotifications = () => {
  const queryClient = useQueryClient();

  const all = useQuery({
    queryKey: ['notifications'],
    queryFn: async () => {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 500));
      return mockNotifications;
    },
    staleTime: 30000, // 30 seconds
  });

  const markRead = useMutation({
    mutationFn: async (id: string) => {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 200));
      return { id, success: true };
    },
    onSuccess: (data) => {
      queryClient.setQueryData(['notifications'], (old: any) => {
        if (!old) return old;
        return old.map((notification: any) =>
          notification.id === data.id
            ? { ...notification, read: true }
            : notification
        );
      });
    },
  });

  const markAllRead = useMutation({
    mutationFn: async () => {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 300));
      return { success: true };
    },
    onSuccess: () => {
      queryClient.setQueryData(['notifications'], (old: any) => {
        if (!old) return old;
        return old.map((notification: any) => ({ ...notification, read: true }));
      });
    },
  });

  const deleteNotification = useMutation({
    mutationFn: async (id: string) => {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 200));
      return { id, success: true };
    },
    onSuccess: (data) => {
      queryClient.setQueryData(['notifications'], (old: any) => {
        if (!old) return old;
        return old.filter((notification: any) => notification.id !== data.id);
      });
    },
  });

  return { 
    all, 
    markRead, 
    markAllRead, 
    deleteNotification 
  };
};
